import api from "./api";

export const saveSessionID = async(payload) => {
    try{
        const response = await api.post("/feedback/save_session_id",payload)
        // console.log("Response => ", response)
    }catch(error){
        console.error("Error => ",error )
    }
}

export const saveFeedbackForm = async(payload) => {
    try{
        const response = await api.post("/feedback/submit_feedback_form",payload)
        // console.log("Response => ", response)
    }catch(error){
        console.error("Error => ",error )
    }
}


export const feedbackFormStatus = async(payload) => {
    try{
        const response = await api.post("/feedback/get_feedback_form_status",payload)
        // console.log("Response => ", response)
        return response.data.data
    }catch(error){
        console.error("Error => ",error )
    }
}


export const feedbackNotInterestedStatusChange = async(payload) => {
    try{
        const response = await api.put("/feedback/change_feedback_status",payload)
        // console.log("Response => ", response)
        return response.data.data
    }catch(error){
        console.error("Error => ",error )
    }
}


export const getAllFeedbacks = async (payload) => {
    try {
        const response = await api.get("/feedback/get_all_feedbacks", {
            params: payload
        })
        // console.log("Response => ", response)
        return response.data
    } catch (error) {
        console.error("Error => ", error)
        throw error; // Don't forget to throw the error
    }
}



export const getSpecificFeedback = async(payload) => {
    try{
        const response = await api.post("/feedback/get_specific_feedback",payload)
        // console.log("Response => ", response)
        return response.data.data
    }catch(error){
        console.error("Error => ",error )
    }
}
